export default {
    error: false,
    loading: {
        module:false,
    },
    message_loading : 'Cargando Plantilla De Incorporación De Clientes',
    file: ''
};



// WEBPACK FOOTER //
// ./src/modules/import-terceros/state.js